import * as actionTypes from './actionTypes';
import { submitTaskApi,getTaskConfigApi,getImgSegmentQuestionApi,getNextImgSegmentDatasetApi,getImgSegmentDatasetsApi } from '../../apiUtils/api';

export const updateQuery=(query)=>{
    return { type: actionTypes.IMG_SEGMENT_QUERY_RECEIVED, query: query };
}

export const getTaskConfig=(jwt,taskAcceptedInfoId)=>{
    return dispatch => getTaskConfigApi(jwt,taskAcceptedInfoId).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.IMG_SEGMENT_GET_TASK_CONF_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.IMG_SEGMENT_GET_TASK_CONF_SUCCESS, task: data.task, taskAccessKey: data.taskAccessKey });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.IMG_SEGMENT_GET_TASK_CONF_ERROR, error: err});
    })
}

export const getCurrentSegmentQuestion=(jwt,taskAccessKey)=>{
    return dispatch => getImgSegmentQuestionApi(jwt,taskAccessKey).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.IMG_SEGMENT_GET_CURRENT_QUESTION_ERROR,error: data.error});
        }else {
            let taskContinue=data.imgSegmentQuestion.is_img_segment;
            dispatch({type: actionTypes.IMG_SEGMENT_GET_CURRENT_QUESTION_SUCCESS, imgSegmentQuestion: data.imgSegmentQuestion, taskContinue});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.IMG_SEGMENT_GET_CURRENT_QUESTION_ERROR, error: err});
    })
}

export const getNextImageSegmentDataset=(jwt,imgSegmentQuestionId)=>{
    return dispatch => getNextImgSegmentDatasetApi(jwt,imgSegmentQuestionId).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.IMG_SEGMENT_GET_NEXT_SEGMENT_DATASET_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.IMG_SEGMENT_GET_NEXT_SEGMENT_DATASET_SUCCESS, imgSegmentDataset: data.imgSegmentDataset});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.IMG_SEGMENT_GET_NEXT_SEGMENT_DATASET_ERROR, error: err});
    })
}

export const openLightBox=()=>{
    return { type: actionTypes.IMG_SEGMENT_OPEN_LIGHTBOX };
}

export const closeLightBox=()=>{
    return { type: actionTypes.IMG_SEGMENT_CLOSE_LIGHTBOX };
}

export const updateAnswer=(imgSegmentForm)=>{
    return { type: actionTypes.IMG_SEGMENT_UPDATE_ANSWER,imgSegmentForm: imgSegmentForm};
}

export const submitResult=(jwt,imgSegmentForm,taskAcceptedInfoId)=>{
    let payload={};
    payload.taskAcceptedInfoId=taskAcceptedInfoId;
    payload.answerTotalObjDetected=imgSegmentForm.answerTotalObjDetected;
    payload.answerImgObjNa=imgSegmentForm.answerImgObjNa;
    payload.answerImgNotLoad=imgSegmentForm.answerImgNotLoad;

    let taskContinue=true;
    let taskCompleted=false;

    if (imgSegmentForm.answerImgObjNa || imgSegmentForm.answerImgNotLoad){
        taskContinue=false;
        taskCompleted=true;
    }

    return dispatch => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.IMG_SEGMENT_SUBMIT_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.IMG_SEGMENT_SUBMIT_SUCCESS, taskContinue, taskCompleted });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.IMG_SEGMENT_SUBMIT_ERROR, error: err});
    })
}

export const taskCompleted=()=>{
    return { type: actionTypes.IMG_SEGMENT_TASK_COMPLETED };
}

export const getImgSegmentDatasets=(jwt,page,pageSize,sortField,sortOrder,imgSegmentQuestionId)=>{
    return dispatch => getImgSegmentDatasetsApi(jwt,page,pageSize,sortField,sortOrder,imgSegmentQuestionId)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.GET_IMG_SEGMENT_DATASETS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.GET_IMG_SEGMENT_DATASETS_SUCCESS, data: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.GET_IMG_SEGMENT_DATASETS_ERROR,error: err});
    })
}

export const setPage=(jwt,imgSegment,page)=>{
    return getImgSegmentDatasets(jwt,page,imgSegment.pageSize,imgSegment.sortField,imgSegment.sortOrder,imgSegment.imgSegmentQuestionId);
}

export const setPageSize=(jwt,imgSegment,pageSize)=>{
    return getImgSegmentDatasets(jwt,imgSegment.page,pageSize,imgSegment.sortField,imgSegment.sortOrder,imgSegment.imgSegmentQuestionId);
}

export const sortData=(jwt,imgSegment,sortField,sortOrder)=>{
    return getImgSegmentDatasets(jwt,imgSegment.page,imgSegment.pageSize,sortField,sortOrder,imgSegment.imgSegmentQuestionId);
}


// WEBPACK FOOTER //
// ./src/redux/imgSegment/actions.js